const moment = require('moment')

const rePersonnummer = /^(\d{2})?(\d{2})(\d{2})(\d{2})([-+])?(\d{4})$/

module.exports = function normalizeSvensktPersonnummer(input) {
  const match = rePersonnummer.exec(input.replace(/\s/g, ''))

  if (!match) return input

  const parts = match.slice(1)
  const currentDate = moment().format('YYYYMMDD')
  const currentCentury = currentDate.substring(0, 2)

  // eslint-disable-next-line prefer-const
  let [century = currentCentury, year, month, day, separator = '-', digits] = parts

  if (`${century}${year}${month}${day}` > currentDate) {
    century = String(Number(century) - 1)
  }

  if (separator === '+') {
    century = String(Number(century) - 1)
  }

  return `${century}${year}${month}${day}${digits}`
}
